/* tslint:disable */

/**
 */
export class CardMonthRevenueForm {
    from_date?: string;
    to_date?: string;
    route_id?: number;
}
